var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllergensWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon allergens white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-allergens-white",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1365301,27.2535594 C25.5326148,28.3398558 24.7333333,31.7435846 24.7333333,31.7435846 C24.7333333,31.7435846 28.6819318,33.6140304 31.2858472,32.5272035 C33.8897625,31.4411724 35.1333333,27.3734632 35.1333333,27.3734632 C35.1333333,27.3734632 30.7404455,26.167263 28.1365301,27.2535594",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7365352,21.1869398 C28.1325514,22.2732032 27.3333333,25.6768285 27.3333333,25.6768285 C27.3333333,25.6768285 31.2818937,27.5472177 33.8856026,26.4606889 C36.4893116,25.3744255 37.7333333,21.3065747 37.7333333,21.3065747 C37.7333333,21.3065747 33.3399694,20.1006764 30.7365352,21.1869398",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4696836,15.1201488 C29.8659058,16.206671 29.0666667,19.6102761 29.0666667,19.6102761 C29.0666667,19.6102761 33.0153312,21.4803888 35.6185595,20.3941319 C38.2228867,19.3078749 39.4666667,15.2403135 39.4666667,15.2403135 C39.4666667,15.2403135 35.0737361,14.0338918 32.4696836,15.1201488",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8572294,8.18358894 C32.1376116,9.91080895 32.5860135,12.9236762 32.5860135,12.9236762 C32.5860135,12.9236762 36.3127523,13.1490864 38.0323701,11.4218664 C39.7522228,9.69464636 39.4454585,6 39.4454585,6 C39.4454585,6 35.577082,6.45683131 33.8572294,8.18358894",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8401143,11.4103298 C24.9560769,8.8118183 26.7976507,6 26.7976507,6 C26.7976507,6 30.5589071,7.63241818 31.4426884,10.2311886 C32.3269819,12.8302178 30.3074225,16.4 30.3074225,16.4 C30.3074225,16.4 26.7238956,14.0091002 25.8401143,11.4103298",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2402228,18.3443156 C22.3559781,15.7452216 24.1974504,12.9333333 24.1974504,12.9333333 C24.1974504,12.9333333 27.9584996,14.566051 28.8427444,17.164886 C29.7269891,19.7637212 27.7070289,23.3333333 27.7070289,23.3333333 C27.7070289,23.3333333 24.1242115,20.9431506 23.2402228,18.3443156",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6402367,24.4107128 C19.755941,21.812266 21.5975193,19 21.5975193,19 C21.5975193,19 25.3587848,20.6328952 26.2428244,23.231601 C27.1268639,25.8303066 25.1070436,29.4 25.1070436,29.4 C25.1070436,29.4 21.5240201,27.0094185 20.6402367,24.4107128",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4000212,41.040797 C20.3930606,36.2522032 22.1020473,32.8137677 24.6208885,28.5333333 L26.4666667,29.4224752 C23.9693127,33.6867383 22.4978955,36.6819734 22.4909348,41.040797 C22.4909348,42.1615433 22.5911073,43.3776724 22.8050711,44.7305713 L22.8050711,44.7311195 L20.7353421,45 C20.5092729,43.5711785 20.4000212,42.2637782 20.4000212,41.040797",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2666667,44.7360258 L19.5291707,45 C19.5291707,45 16.7876414,34.8277284 16.2485324,34.2578879 C15.7091694,33.6877788 10,38.3141752 10,38.3141752 C10,38.3141752 16.3753069,26.5467797 17.3902647,28.8264105 C17.6755707,29.1279802 21.2666667,44.7360258 21.2666667,44.7360258",
    id: "Fill-9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergensWhite);
export default __webpack_public_path__ + "static/media/allergens-white.4ea99b3508816fac68adfb1dd2c709da.svg";
export { ForwardRef as ReactComponent };